/**
 * Merges multiple aria-describedby IDs into a single space-separated string.
 * Filters out undefined/null values and returns undefined if no valid IDs are provided.
 *
 * @param ids - Array of ID strings or undefined values
 * @returns Space-separated string of IDs or undefined if no valid IDs
 *
 * @example
 * mergeAriaDescribedBy('id1', 'id2', undefined) // 'id1 id2'
 * mergeAriaDescribedBy(undefined, undefined) // undefined
 * mergeAriaDescribedBy('id1') // 'id1'
 */
export const mergeAriaDescribedBy = (...ids: Array<string | undefined>): string | undefined => {
  const filtered = ids.filter(Boolean).join(' ');
  return filtered || undefined;
};
